import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Moon } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { track, identify, planOf } from "@/lib/analytics";
import { takeReturnTo, clearReturnTo } from "@/lib/returnTo";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, refreshEntitlements } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      window.history.replaceState(null, "", window.location.pathname);
      if (!sessionId) {
        clearReturnTo();
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        // Load entitlements BEFORE navigating home so the navbar renders the
        // correct Premium/Upgrade state immediately (no manual refresh needed).
        const ent = await refreshEntitlements();
        identify(res.data.user_id, planOf(ent));
        track("sign_in_completed", { plan: planOf(ent), method: "google" });
        navigate(takeReturnTo(), { replace: true, state: { user: res.data } });
      } catch (e) {
        clearReturnTo();
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate, setUser, refreshEntitlements]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <Moon className="h-10 w-10 animate-pulse text-[#D9A441]" />
      <p className="font-display text-xl text-[#F8F3E6]">Aligning the stars…</p>
    </div>
  );
};
